<template>
  <div class="userinfo">
    <p class="userinfo-text">
      <span class="userinfo-text-welcome">{{ letter.storeWelcome }}：</span>
      <span class="userinfo-text-account">{{ loginAccount }}</span>
    </p>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'UserInfo',
  computed: {
    ...mapState({
      letter: state => state.letter,
      loginAccount: state => state.login.loginAccount
    })
  }
};
</script>

<style lang="scss" scoped>
.userinfo {
  color: #ffffff;
  &-text {
    display: inline-block;
    // margin-left: 22px;
    font-size: 24px;
    vertical-align: middle;
  }
}
</style>
